import {
  costRecordSend,
  getCostDetail,
  getCostContentDatas,
  saveCostMaintainDatas,
  getInqueryNum,
  getMaintainTeam
} from '@/services/costMaintain'
import { getMessageSource } from '@/services/statistic'
import i18n from '@/lib/language'

const costDetailColumns = [
  {
    title: i18n.t('message["1257"]'),
    dataIndex: 'maintainContent',
    width: 120,
    scopedSlots: { customRender: 'maintainContent' }
  },
  {
    title: i18n.t('message["288"]'),
    dataIndex: 'maintainFrom',
    width: 120,
    scopedSlots: { customRender: 'maintainFrom' }
  },
  {
    title: i18n.t('message["1428"]'),
    dataIndex: 'inquirynum',
    width: 90,
    key: 'inquirynum'
  },
  {
    title: i18n.t('message["1138"]'),
    dataIndex: 'realinquirynum',
    width: 120,
    scopedSlots: { customRender: 'realinquirynum' }
  },
  {
    title: i18n.t('message["623"]'),
    dataIndex: 'netCost',
    width: 120,
    scopedSlots: { customRender: 'netCost' }
  },
  {
    title: i18n.t('message["1427"]'),
    width: 100,
    dataIndex: 'netCostPreInquiry'
  },
  {
    title: i18n.t('message["539"]'),
    dataIndex: 'grossCost',
    width: 100,
    scopedSlots: { customRender: 'grossCost' }
  },
  {
    title: i18n.t('message["1426"]'),
    dataIndex: 'grossCostPreInquiry'
  },
  {
    title: i18n.t('message["79"]'),
    dataIndex: 'operate',
    scopedSlots: { customRender: 'operate' }
  }
]
export default {
  namespaced: true,
  state: {
    radioTypeDatas: [
      { name: i18n.t('message["914"]'), value: '0' },
      { name: i18n.t('message["1603"]'), value: '1' },
      { name: i18n.t('message["1602"]'), value: '2' }
    ],
    inqueeryNum: 0, // 询盘数量
    saveLoading: false,
    sendSelectLists: [], // 发送待选择数据列表
    sendDialogVisible: false, // 发送弹窗
    addBtnStatus: true, // 新增按钮 状态
    costDetailColumns, // 成本维护详情table表头数据
    fromDataLists: [], // 来源信息数据
    costDetail: [], // 成本维护详情页面数据
    costDetailTitle: '',
    loadingContentDetail: false,
    costMaintainDetail: {}, // 成本维护详情
    costMaintainContentLists: [], // 成本维护内容列表
    costContentData: [], // 移动端成本维护内容
    detailSnapForm: {}, // 成本维护详情表单临时数据
    sendDetailFormData: {}, // 发送表单数据
    sendSelectTree: {
      members: []
    }, // 发送选择的树形数据
    loadingContent: true
  },
  mutations: {
    setInqueeryNum (state, data) {
      state.inqueeryNum = data
    },
    setLoadingContentDetail (state, data) {
      state.loadingContentDetail = data
    },
    setFromDataLists (state, data) {
      state.fromDataLists = data
    },
    setCostMaintainDetail (state, data) {
      state.costMaintainDetail = data
    },
    setCostContentData (state, data) {
      state.costContentData = []
      state.costContentData.push(...data)
    },
    setCostDetail (state, result) {
      state.costDetail = []
      state.costDetail.push(...result)
    },
    setPushCostDetail (state, data) {
      state.costDetail.push(data)
    },
    setCostDetailTitle (state, title) {
      state.costDetailTitle = title
    },
    setCostMaintainContentLists (state, data) {
      state.costMaintainContentLists = data
    },
    setAddBtnStatus (state, data) {
      state.addBtnStatus = data
    },
    setSendDialogVisible (state, data) {
      state.sendDialogVisible = data
    },
    setSaveLoading (state, data) {
      state.saveLoading = data
    },
    setSendSelectLists (state, data) {
      state.sendSelectLists = data
    },
    setSendDetailFormData (state, data) {
      const { key, value } = data
      state.sendDetailFormData[key] = value
    },
    clearSendDetailFormData (state) {
      state.sendDetailFormData = {}
    },
    setDetailSnapForm (state, data) {
      for (let key in data) {
        // 深度监听，可以更新dom
        state.detailSnapForm = Object.assign({}, state.detailSnapForm, {
          [key]: data[key]
        })
      }
    },
    clearDetailSnapForm (state) {
      state.detailSnapForm = {}
    },
    setSendSelectTree (state, data) {
      const { value, members } = data
      state.sendSelectTree = { value, members }
    },
    clearSendSelectTree (state) {
      state.sendSelectTree = { members: [] }
    },
    initDetailSnapForm (state) {
      state.detailSnapForm = Object.assign(
        {},
        state.detailSnapForm,
        { maintainContent: i18n.t('message["855"]') },
        { maintainFrom: i18n.t('message["855"]') }
      )
    },
    setLoadingContent (state, data) {
      state.loadingContent = data
    }
  },
  actions: {
    // 获取成本维护首页数据方法
    async fetchCostRecordSend ({ commit }, params) {
      const chain = await costRecordSend()
        .onSuccess(payload => {
          commit('setSaveLoading', false)
          commit('setSendDialogVisible', false)
        })
        .params({
          ...params
        })
        .config({
          tip: true
        })
        .fetch()
      return chain
    },
    // 移动端发送维护成本
    async sendCost ({ commit }, params) {
      const chain = await costRecordSend()
        .params({ ...params })
        .config({ tip: false })
      return chain
    },
    // 获取涞源信息数据
    async fetchGetMessageSource ({ commit }) {
      const chain = await getMessageSource()
        .onSuccess(payload => {
          commit('setFromDataLists', payload)
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 获取涞源信息数据
    async fetchGetInqueryNum ({ commit }, params) {
      const chain = await getInqueryNum()
        .onSuccess(payload => {
          commit('setInqueeryNum', payload)
        })
        .params({ ...params })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 获取数据详情
    async fetchGetCostDetail ({ dispatch, commit }, params) {
      commit('setLoadingContent', true)
      commit('setLoadingContentDetail', true)
      const chain = await getCostDetail()
        .onNetSuccess(raw => {
          if (params.key) {
            const { key, period } = params
            dispatch('formateDetailDatas', {
              key,
              period,
              data: raw.data.payload.data
            })
          } else {
            const { title, data } = raw.data.payload
            commit('setCostDetail', data)
            commit('setCostDetailTitle', title)
          }
          commit('setLoadingContent', false)
          commit('setLoadingContentDetail', false)
        })
        .params({
          ...params
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 获取数据详情
    async fetchGetCostContentDatas ({ commit }) {
      const chain = await getCostContentDatas()
        .onSuccess(payload => {
          commit('setCostMaintainContentLists', payload)
          commit('setSendSelectLists', payload)
        })
        .params({
          pk: 'inquiry-dev'
        })
        .config({
          tip: false
        })
        .fetch()
      return chain
    },
    // 获取数据详情
    async fetchSaveCostMaintainDatas ({ commit, dispatch }, params) {
      const chain = await saveCostMaintainDatas()
        .onSuccess(payload => {
          commit('setAddBtnStatus', true)
          dispatch('fetchGetCostDetail', { period: params.period })
        })
        .params({
          ...params
        })
        .config({
          tip: true
        })
        .fetch()
      return chain
    },

    formateDetailDatas ({ commit, state }, data) {
      let tempv = JSON.parse(JSON.stringify(state.costMaintainDetail))
      tempv[data.key] = {}
      tempv[data.key][data.period] = data.data
      commit('setCostMaintainDetail', tempv)
    },
    // 获取维护内容团队
    async fetchMaintainTeam ({ commit }) {
      const chain = await getMaintainTeam()
        .params({ pk: 'inquiry-dev', type: 0, deal: 1 })
        .onSuccess(res => {
          commit('setCostContentData', res)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    // 保存成本维护记录
    async fetchAddCost ({ commit }, params) {
      const chain = await saveCostMaintainDatas()
        .params(params)
        .config({ tip: false })
      return chain
    },
    // 获取询盘数量信息数据
    async getInqueryNum ({ commit }, params) {
      const chain = await getInqueryNum()
        .params({ ...params })
        .config({
          tip: false
        })
      return chain
    },
    clearCrumb ({ commit }) {
      commit('clearDetailSnapForm')
    }
  }
}
